import { Config } from 'final-form'
import { defineComponent } from 'vue'

import { MovementTypes } from '@skinsoft/types'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { BarcodeReader, Field, Form } from '@skinsoft/ui'
import { LocationSelector } from '@skinsoft/entity-ui'

export interface Values {
    location: string;
    permanentLocation?: boolean;
    usePermanentLocItemAsDestination?: boolean;
}

export const CloseForm = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sBarcodeReader: BarcodeReader,
        sLocationSelector: LocationSelector
    },
    props: ['onSubmit', 'initialValues', 'movementType'],
    template: require('./close-form.html'),
    data() {
        return {
            MovementTypes: MovementTypes,
            isLocationSelected: false,
            usePermanentLocItemAsDestination: undefined as boolean | undefined,
        }
    },
    mounted() {
        this.usePermanentLocItemAsDestination = this.initialValues.usePermanentLocItemAsDestination
    },
    methods: {
        validate(values): Promise<object> {
            return new Promise(resolve => {
                this.usePermanentLocItemAsDestination = values.usePermanentLocItemAsDestination
                // need to be a promise to avoid conflict with $t mixin
                const errors = {} as any;

                if (this.movementType === MovementTypes.SIMPLE) {
                    if (!values.location && !values.usePermanentLocItemAsDestination) {
                        errors.location = this.$t('entity.closeMovement.form.location.emptyError');
                    }
                }

                resolve(errors);
            });
        },
        onBarcodeReaderInput(location: Values['location']) {
            const form = (this.$refs.form as InstanceType<typeof Form>).form;

            form.batch(() => {
                form.change('location', location);
                form.mutators.setFieldTouched('location', true);
            });
        },
        onLocationSelected(locationChangeEvent) {
            if (locationChangeEvent.location) {
                this.isLocationSelected = true;
                const form = (this.$refs.form as InstanceType<typeof Form>).form;

                form.batch(() => {
                    form.change('location', locationChangeEvent.location);
                    form.mutators.setFieldTouched('location', true);
                });
            } else {
                this.isLocationSelected = false;
            }
        },
    },
})
